import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import styles from './TableDrawerEmptyState.module.scss';
import { Icon } from '@/components/ui/Icon';
import { SectionBox } from '@/components/ui/SectionBox';

export const TableDrawerEmptyState = ({ text }: { text?: string }) => {
  const { t } = useTranslation('ui');

  return (
    <SectionBox>
      <Stack alignItems="center" justifyContent="center" gap={2}>
        <div className={styles.IconWrapper}>
          <Icon
            aria-hidden
            // eslint-disable-next-line local/no-icon-string-literals
            name="table_rows_narrow"
            size="xxxLarge"
            color="secondary"
            weight={200}
          />
          <Icon
            aria-hidden
            className={styles.ClickIcon}
            // eslint-disable-next-line local/no-icon-string-literals
            name="left_click"
            size="xLarge"
            color="secondary"
          />
        </div>
        <Typography color="secondary" textAlign="center">
          {text ?? t('emptyState.TableDrawerDefaultText')}
        </Typography>
      </Stack>
    </SectionBox>
  );
};
